export const stringCompare = (str1, str2) =>
  str1 && str2 && typeof str1 === 'string' && typeof str2 === 'string' && str1.toLowerCase() === str2.toLowerCase();

export interface SingleTrainClass {
  code: string;
  value: string;
}

interface trainClassInterface {
  [key: string]: SingleTrainClass;
}

export const TrainClasses: trainClassInterface = Object.freeze({
  AllClasses: {
    code: '',
    value: 'All Classes'
  },
  OneA: {
    code: '1A',
    value: '1st Class AC'
  },
  TwoA: {
    code: '2A',
    value: '2 Tier AC'
  },
  ThreeA: {
    code: '3A',
    value: '3 Tier AC'
  },
  SL: {
    code: 'SL',
    value: 'Sleeper'
  },
  TwoS: {
    code: '2S',
    value: 'Second Sitting'
  },
  CC: {
    code: 'CC',
    value: 'AC Chair Car'
  },
  EA: {
    code: 'EA',
    value: 'Executive Anubhuti'
  },
  FC: {
    code: 'FC',
    value: 'First Class'
  },
  ThreeE: {
    code: '3E',
    value: 'AC three tier(economy)'
  },
  EC: {
    code: 'EC',
    value: 'Executive Chair Car'
  },
  URGN: {
    code: 'UR/GEN',
    value: 'Unreserved/General'
  }
});

export const AcClasses = {
  '1A': 'AC',
  '2A': 'AC',
  '3A': 'AC',
  CC: 'AC',
  EA: 'AC',
  EC: 'AC'
};

export const getClassType = (value) =>
  Object.values(TrainClasses).find((classType) => stringCompare(classType.code, value));
